(function(){

"use strict";


window.AI_GIFT_MESSAGE={

enabled:false,
name:"",
date:"",
message:""

};



document.addEventListener(
"DOMContentLoaded",
function(){



const config =
window.ART_CONFIG?.get(
window.CURRENT_SKU
);



const custom =
config?.customInput;



const checkbox =
document.getElementById(
"ai-gift-enable"
);



const toggle =
document.getElementById(
"ai-gift-toggle"
);



const fields =
document.getElementById(
"ai-gift-fields"
);




if(!fields){

return;

}





/*
====================================
动态UI
====================================
*/


if(custom?.enabled){


const title =
document.getElementById(
"ai-gift-title"
);


const desc =
document.getElementById(
"ai-gift-description"
);


if(title){

title.innerHTML =
custom.title || "Personalize Your Artwork";

}



if(desc){

desc.innerHTML =
custom.description || "";

}





// 必填模式
if(custom.required){


window.AI_GIFT_MESSAGE.enabled=true;



if(fields){

fields.classList.remove(
"ai-hidden"
);

}



if(toggle){

toggle.style.display="none";

}



}




// 字段控制

// ====================================
// 字段控制
// ====================================

const fieldsConfig =
custom.fields || {};



[
    "name",
    "date",
    "message"

].forEach(function(field){


    const config =
    fieldsConfig[field];


    if(
        config &&
        config.enabled===false
    ){


        const label =
        document.getElementById(
            "gift-" + field + "-label"
        );


        const input =
        document.getElementById(
            "ai-gift-" + field
        );



        if(label){

            label.style.display="none";

        }



        if(input){

            input.style.display="none";

        }


    }



});





if(fieldsConfig.name?.label){

document
.getElementById(
"gift-name-label"
)
.innerText =
fieldsConfig.name.label;

}



if(fieldsConfig.date?.label){

document
.getElementById(
"gift-date-label"
)
.innerText =
fieldsConfig.date.label;

}



if(fieldsConfig.name?.placeholder){

document
.getElementById(
"ai-gift-name"
)
.placeholder =
fieldsConfig.name.placeholder;

}


if(fieldsConfig.date?.placeholder){

document
.getElementById(
"ai-gift-date"
)
.placeholder =
fieldsConfig.date.placeholder;

}


}






/*
====================================
checkbox模式
====================================
*/


if(checkbox){


checkbox.addEventListener(
"change",
function(){


window.AI_GIFT_MESSAGE.enabled =
this.checked;



if(this.checked){

fields.classList.remove(
"ai-hidden"
);


}else{


fields.classList.add(
"ai-hidden"
);


clearGift();


}


updateGift();


});


}






[
"ai-gift-name",
"ai-gift-date",
"ai-gift-message"

].forEach(id=>{


const input =
document.getElementById(id);



if(input){


input.addEventListener(
"input",
updateGift
);


}


});





// required模式自动打开

if(custom?.enabled && custom.required){

updateGift();

}



});







function updateGift(){


const data={


enabled:
window.AI_GIFT_MESSAGE.enabled
||
document.getElementById(
"ai-gift-enable"
)?.checked
||
false,


name:
document.getElementById(
"ai-gift-name"
)?.value
||
"",



date:
document.getElementById(
"ai-gift-date"
)?.value
||
"",



message:
document.getElementById(
"ai-gift-message"
)?.value
||
""



};



window.AI_GIFT_MESSAGE=data;





const nameInput =
document.getElementById(
"gift-name-property"
);


const dateInput =
document.getElementById(
"gift-date-property"
);


const messageInput =
document.getElementById(
"gift-message-property"
);




if(nameInput){

nameInput.value=data.name;

}


if(dateInput){

dateInput.value=data.date;

}


if(messageInput){

messageInput.value=data.message;

}



console.log(
"[AI Gift Updated]",
data
);



}








function clearGift(){


window.AI_GIFT_MESSAGE={

enabled:false,

name:"",

date:"",

message:""

};


updateGift();


}



})();